import { useEffect } from "react";
import { toast } from "sonner";
import { AdSenseBanner } from "./AdSenseBanner";

/**
 * Renders the AdSense banner slot and listens for the global
 * `freemium:monthly-limit` event fired by `lib/api.js` when the backend
 * returns 403 MONTHLY_LIMIT_EXCEEDED. Shows a soft "Upgrade to Reads+"
 * toast — the rest of the app remains fully accessible.
 */
export function FreemiumGate() {
  useEffect(() => {
    const onLimit = () => {
      toast.message("Monthly limit reached", {
        description:
          "You've reached your monthly limit. Upgrade to Reads+ for unlimited books, unlimited recommendations, and no ads.",
        duration: 8000,
        action: {
          label: "Upgrade",
          onClick: () => {
            window.location.href = "/subscribe";
          },
        },
      });
    };
    window.addEventListener("freemium:monthly-limit", onLimit);
    return () => window.removeEventListener("freemium:monthly-limit", onLimit);
  }, []);

  return <AdSenseBanner />;
}
